export const settings = {
    appName: config.appName,
    appUrl: config.appUrl,
    apiUrl: config.apiUrl,
    facebook: config.facebook,
    google: config.google,
    device: config.device,
    name: config.name
};
